import React from 'react';
import { motion, AnimatePresence } from "framer-motion"


const FadeIn = React.memo(
    (props: { children: React.ReactNode; }) => {
        const variants = {
            visible: { opacity: 1 },
            hidden: { opacity: 0 },
        }

        return (
            <motion.div
                initial="hidden"
                animate="visible"
                variants={variants}
                transition={{ duration: 1 }}
            ><AnimatePresence>
                {props.children}
                </AnimatePresence>

            </motion.div>
        );
    })

export default FadeIn